import { __, Alert, confirm } from 'modules/common/utils';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import {ButtonCommonTheme} from 'modules/theme'
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel
} from 'modules/common/components';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/common/styles/main';

class SIPAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.handleEditModalShowHide = this.handleEditModalShowHide.bind(this);

    this.mAPI = new APIManager();
    if (this.props.editData) {
      this.state = {
        sip: this.props.editData.sip,
        password: this.props.editData.password,
        shoowHideEdit: false
      };
    } else {
      this.state = {
        sip: '',
        password: '',
        shoowHideEdit: false
      };
    }
  }

  handleEditModalShowHide() {
    this.setState({ shoowHideEdit: !this.state.shoowHideEdit });
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      sip: '',
      password: ''
    });
  }

  saveData(e) {
    e.preventDefault();
    let tData = {
      sip: this.state.sip,
      password: this.state.password
    };
    this.mAPI.sendPostAPI(
      `setting/sip/${this.props.editData._id}`,
      tData,
      data => {
        console.log(JSON.stringify(data, null, 2));
        // this.handleEditModalShowHide();
        // this.resetAllData();
        // Alert.success(`SIP Extension ${tData.sip} is Updated.`);
        // this.resetAllData();
        // Alert.success(`SIP Extension ${tData.sip} is Updated.`);
        // this.props.closeModel(tData);
      },
      (errorCode, data) => {
        console.log(`Error:`, errorCode);
        if (errorCode === 200) {
          this.handleEditModalShowHide();
          Alert.success(`SIP Extension ${tData.sip} is Updated.`);
          // this.resetAllData();
          Alert.success(`${errorCode} : ${data.message}`);
        } else {
          Alert.error(`${errorCode} : ${data.message}`);
        }
      },
      'private',
      { id: tData._id },
      'PUT'
    );
  }

  render() {
    return (
      <span>
        <Button
          btnStyle="link"
          icon="edit"
          onClick={() => this.handleEditModalShowHide()}
        />
        {/* <Button btnStyle="default" size="small" icon="add" onClick={() => this.handleModalShowHide()}>
                    Add SIP Extension
                </Button> */}
        <Modal show={this.state.shoowHideEdit} className="right">
          <Modal.Header
            closeButton
            onClick={() => this.handleEditModalShowHide()}
          >
            <Modal.Title>Add User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={e => this.saveData(e)}>
              <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup('SIP Extension', {
                    defaultValue: '',
                    autoFocus: true,
                    required: true,
                    id: 'name',
                    value: this.state.sip,
                    onChange: e => {
                      this.setState({ sip: e.target.value });
                    }
                  })}
                </FormColumn>
              </FormWrapper>

              <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup('Password', {
                    defaultValue: '',
                    autoFocus: true,
                    required: true,
                    type: 'password',
                    value: this.state.password,
                    onChange: e => {
                      this.setState({ password: e.target.value });
                    },
                    id: 'password'
                  })}
                </FormColumn>
              </FormWrapper>
              <ModalFooter>
                <ButtonCommonTheme
                  type='blueModalBtn'
                  btnType="submit"
                  btnStyle="default"
                  // onClick={() => this.saveData()}
                  icon="checked-1"
                >
                  Save
                </ButtonCommonTheme>
              </ModalFooter>
            </form>
          </Modal.Body>
        </Modal>
        {/* <form onSubmit={e => this.saveData(e)}>
                    <FormWrapper>
                        <FormColumn>
                            {this.renderFormGroup('SIP Extension', {
                                defaultValue: '',
                                autoFocus: true,
                                required: true,
                                id: 'name',
                                value: this.state.sip,
                                onChange: e => {
                                    this.setState({ sip: e.target.value });
                                }
                            })}
                        </FormColumn>
                    </FormWrapper>

                    <FormWrapper>
                        <FormColumn>
                            {this.renderFormGroup('Password', {
                                defaultValue: '',
                                autoFocus: true,
                                required: true,
                                value: this.state.password,
                                onChange: e => {
                                    this.setState({ password: e.target.value });
                                },
                                id: 'password'
                            })}
                        </FormColumn>
                    </FormWrapper>
                    <ModalFooter>
                        <Button
                            type="submit"
                            btnStyle="default"
                            // onClick={() => this.saveData()}
                            icon="checked-1"
                        >
                            Save
                        </Button>
                        <Button
                            btnStyle="default"
                            onClick={() => this.props.closeModel()}
                            icon="checked-1"
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </form> */}
      </span>
    );
  }
}

SIPAddEdit.propTypes = {
  group: PropTypes.array
};

SIPAddEdit.contextTypes = {
  __: PropTypes.func
};

export default SIPAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/SIP/components/SIPAddEdit.js